import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, Mail, MapPin, Phone, Truck } from 'lucide-react';
import { SocialLinks } from './SocialLinks';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Logo } from './Logo';
import { CONTACT_EMAIL, CONTACT_EMAIL_HREF, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_HREF, DELIVERY_CITIES, PICKUP_ADDRESS, PICKUP_MAP_URL, SHOPIFY_CHECKOUT_URL, SITE_DOMAIN } from '../data/contact';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const navigation = [{
    name: t.nav.cacao,
    to: '/#cacao'
  }, {
    name: t.nav.creations,
    to: '/#creations'
  }, {
    name: t.nav.ingredients,
    to: '/#ingredients'
  }, {
    name: t.nav.giftCard,
    to: '/#carte-cadeau'
  }, {
    name: t.nav.recipes,
    to: '/recettes'
  }, {
    name: t.nav.events,
    to: '/evenements'
  }, {
    name: t.nav.cart,
    to: '/panier'
  }, {
    name: t.nav.contact,
    to: '/contact'
  }];
  return <footer className="bg-cacao-900 pb-10 pt-20 text-creme" data-id="element-53" data-mp="3l9agxskjxm96">
      <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-54" data-mp="3lbmsnnzpv0ds">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-55" data-mp="3gb8s0r0g2sps">
          <div data-id="element-56" data-mp="3v89eog3s3xhe">
            <Link to="/" className="mb-6 inline-block" data-id="element-57" data-mp="3v8rfzr5at1w6">
              <Logo size="h-20 w-20" data-id="element-58" data-mp="3q8mz400ha55f" />
            </Link>
            <p className="mb-6 font-sans text-sm font-light leading-relaxed text-creme/70" data-id="element-59" data-mp="3q724ybi2so83">
              {t.footer.tagline}
            </p>
            <SocialLinks variant="light" data-id="element-60" data-mp="33xefz77o0t1" />
          </div>

          <div data-id="element-61" data-mp="33e69a7d4qs7">
            <h2 className="mb-6 font-serif text-lg text-or" data-id="element-62" data-mp="31upzjlpifqf">
              {t.footer.contactTitle}
            </h2>
            <ul className="space-y-4 font-sans text-sm font-light text-creme/80" data-id="element-63" data-mp="huo87csd59ys">
              <li className="flex items-center gap-3" data-id="element-64" data-mp="cvtnu6eqzdck">
                <Phone size={17} className="shrink-0 text-caramel-light" aria-hidden="true" data-id="element-65" data-mp="qsqadvnu28nn" />
                <a href={CONTACT_PHONE_HREF} className="transition-colors hover:text-caramel-light" data-id="element-66" data-mp="tv4ng298r450">
                  {CONTACT_PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-67" data-mp="13t0xsructv22">
                <Mail size={17} className="mt-0.5 shrink-0 text-caramel-light" aria-hidden="true" data-id="element-68" data-mp="13rfy6nt6nlxc" />
                <a href={CONTACT_EMAIL_HREF} className="break-all transition-colors hover:text-caramel-light" data-id="element-69" data-mp="1cl2qg3y6m71s">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-70" data-mp="1riv5kuztgtfg">
                <MapPin size={17} className="mt-0.5 shrink-0 text-caramel-light" aria-hidden="true" data-id="element-71" data-mp="1rhk0mrumxfmr" />
                <a href={PICKUP_MAP_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-caramel-light" data-id="element-72" data-mp="3t9ge470d4zk6">
                  {PICKUP_ADDRESS}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-73" data-mp="21m0jlu3evcus">
                <CalendarClock size={17} className="mt-0.5 shrink-0 text-caramel-light" aria-hidden="true" data-id="element-74" data-mp="21kfn3yxjdjua" />
                <span data-id="element-75" data-mp="2td6mujefhqoa">{t.contact.ordersValue}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-76" data-mp="2pd5vxza57n0c">
            <h2 className="mb-6 font-serif text-lg text-or" data-id="element-77" data-mp="2pajpy42whfk8">
              {t.footer.navigationTitle}
            </h2>
            <ul className="space-y-3 font-sans text-sm font-light text-creme/80" data-id="element-78" data-mp="2fegpd2np5oze">
              {navigation.map(item => <li key={item.to} data-id="element-79" data-mp="18yecwcyvzs3p">
                  <Link to={item.to} className="transition-colors hover:text-caramel-light" data-id="element-80" data-mp="18zfs8tmxr0r8">
                    {item.name}
                  </Link>
                </li>)}
              <li data-id="element-81" data-mp="2wmziqgk6ijv5">
                <a href={SHOPIFY_CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-caramel-light" data-id="element-82" data-mp="2wnhlzx59dyck">
                  Shopify
                </a>
              </li>
              <li data-id="element-83" data-mp="3bkrv4zufis54">
                <Link to="/remboursement" className="transition-colors hover:text-caramel-light" data-id="element-84" data-mp="3bk8dzlcls7s5">
                  {t.footer.refundLink}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-85" data-mp="36k43qd2ag9ad">
            <h2 className="mb-6 flex items-center gap-3 font-serif text-lg text-or" data-id="element-86" data-mp="36jkq38jo8725">
              <Truck size={18} strokeWidth={1.5} aria-hidden="true" data-id="element-87" data-mp="1q648hfee17tg" />
              {t.orderInfo.deliveryTitle}
            </h2>
            <ul className="flex flex-wrap gap-2" data-id="element-88" data-mp="1v71r1t3b83vh">
              {DELIVERY_CITIES.map(city => <li key={city} className="border border-caramel/30 px-3 py-1 font-sans text-[10px] uppercase tracking-[0.12em] text-creme/80" data-id="element-89" data-mp="1nkebshmxldu8">
                  {city}
                </li>)}
            </ul>
            <p className="mt-4 font-sans text-xs font-light leading-relaxed text-creme/60" data-id="element-90" data-mp="1rnaxwibojs2x">
              {t.orderInfo.deliveryNote}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-creme/10 pt-8 md:flex-row" data-id="element-91" data-mp="zwn1tkov5cw4">
          <p className="text-center font-sans text-xs tracking-wide text-creme/50 md:text-left" data-id="element-92" data-mp="1do1ihkvat200">
            © {new Date().getFullYear()} {SITE_DOMAIN}. {t.footer.rights}
          </p>
          <LanguageSwitcher variant="light" data-id="element-93" data-mp="l6yykdx4g45r" />
        </div>
      </div>
    </footer>;
}